import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./sidebar.css";

// MUI Icons
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import DashboardIcon from "@mui/icons-material/DashboardOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import AltRouteOutlinedIcon from "@mui/icons-material/AltRouteOutlined";
import LocalGasStationOutlinedIcon from "@mui/icons-material/LocalGasStationOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import MyLocationOutlinedIcon from "@mui/icons-material/MyLocationOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import PauseCircleOutlineOutlinedIcon from "@mui/icons-material/PauseCircleOutlineOutlined";
import DirectionsRunOutlinedIcon from "@mui/icons-material/DirectionsRunOutlined";
import FenceOutlinedIcon from "@mui/icons-material/FenceOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import GpsFixedOutlinedIcon from "@mui/icons-material/GpsFixedOutlined";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import WaterDropOutlinedIcon from "@mui/icons-material/WaterDropOutlined";
import SensorsOffOutlinedIcon from "@mui/icons-material/SensorsOffOutlined";
import OilBarrelOutlinedIcon from "@mui/icons-material/OilBarrelOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import CompareArrowsOutlinedIcon from "@mui/icons-material/CompareArrowsOutlined";
import { ReactComponent as DriverIcon } from "./DriverIcon.svg";
import AirlineSeatReclineNormalIcon from "@mui/icons-material/AirlineSeatReclineNormal";
import LockIcon from "@mui/icons-material/Lock";
import RouteIcon from "@mui/icons-material/Route";
import AirlineStopsOutlinedIcon from "@mui/icons-material/AirlineStopsOutlined";
import TuneIcon from '@mui/icons-material/Tune';
import { GiNightSleep } from "react-icons/gi";

// Legacy img imports (kept for sub-menus that still use them)
import logoutIcon from "../../img/logout.png";
import fuelmanagementIcon from "../../img/Fuel Management.svg";
import reportIcon from "../../img/Reports.svg";

import { version } from "../../config/config";
import { themeContext } from "../../App";
import {
  canAccessDigitalLock,
  canAccessFixedGPS,
  getAccessType,
} from "../../utils/accessType";
// Common MUI icon style
const iconStyle = { fontSize: 22, color: "#4a5568", flexShrink: 0 };

function Sidebar() {
  const { color } = useContext(themeContext);
  const history = useHistory();
  const accessType = getAccessType();
  const canAccessLock = canAccessDigitalLock(accessType);
  const canAccessGPS = canAccessFixedGPS(accessType);
  const userType = JSON.parse(localStorage.getItem("data"))?.userType;
  const [permissionAccess, setPermissionAccess] = React.useState(
    JSON.parse(localStorage.getItem("data")),
  );

  // Active route detection for highlighting current menu item
  const location = useLocation();

  const currentPath = location.pathname.split("/")[1] || "";
  const currentSearch = location.search || "";
  const isActive = (route) => {
    const routePath = route.split("?")[0].split("/")[0];
    const routeSearch = route.includes("?") ? "?" + route.split("?")[1] : "";
    if (routeSearch) {
      return currentPath === routePath && currentSearch === routeSearch;
    }
    return currentPath === routePath;
  };
  const navClass = (route) =>
    `navlink${isActive(route) ? " active-nav-item" : ""}`;

  // Helper: returns "active-nav-item" if ANY of the given routes is active.
  // Used for parent menu items that have multiple child routes.
  const isAnyActive = (...routes) => routes.some((r) => isActive(r));

  console.log("permissionAccess", permissionAccess);
  const [parentMenuColor, setParentMenuColor] = React.useState(false);
  console.log(permissionAccess);
  const viewAllUserPermission = permissionAccess?.webPermissionDTOList?.filter(
    (order) => order.name === "USER_MENU",
  );
  const viewAllSitePermission = permissionAccess?.webPermissionDTOList?.filter(
    (order) => order.name === "SITE_MENU",
  );
  const viewAllRoutePermission = permissionAccess?.webPermissionDTOList?.filter(
    (order) => order.name === "ROUTE_MENU",
  );
  const viewAllSubcritionMaster =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "SUBSCRIPTION_MASTER",
    );
  const viewAllVehiclePermission =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "VEHICLE_MENU",
    );
  const viewAllVendorPermission =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "VENDOR_MENU",
    );
  const viewAllTripPermission = permissionAccess?.webPermissionDTOList?.filter(
    (order) => order.name === "GET_ALL_TRIP",
  );
  const viewAllReportPermission =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "GET_ALL_REPORT",
    );
  const viewAllReportAuditPermission =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "GET_AUDIT_LOG_REPORT",
    );
  const viewAllReportActiveRoutesPermission =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "GET_ACTIVE_ROUTES",
    );
  const viewAllDealerLedgerPermission =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "DEALER_LEDGER",
    );

  let dashboardMenu = true;
  let customerDashboardMenu = true;
  let userMenu = true;
  let companyMenu = false;
  let vendorMenu = true;
  let vehicleMenu = true;
  let mapViewMenu = true;
  let siteMenu = true;
  let routeMenu = true;
  let SubscriptionMaster = true;
  let trackMenu = true;
  let tripMenu = true;
  let reportMenu = true;
  let fuelMenu = true;
  let fuelReport = true;
  let notificationMenu = true;
  let permissionControl = false;
  let sidemenu = true;
  let kycMenu = true;
  let dealerLedger = true;
  let activationRenewal = true;
  let customerActivationRenewal = false;
  let myGeofence = true;
  let permissionMenu = true;
  let customerVehicleMenu = true;
  let territoryManagementMenu = false;
  let routeManagementMenu = false;
  let driverMenu = false;

  if (permissionAccess && permissionAccess.userTypeMenuVisiblity) {
    permissionAccess &&
      permissionAccess?.userTypeMenuVisiblity?.forEach((element) => {
        if (element.name == "DASHBOARD") {
          dashboardMenu = element.isVisible;
        }
        if (element.name == "CUSTOMER_DASHBOARD") {
          customerDashboardMenu = element.isVisible;
        }
        if (element.name == "GEOFENCE_MANAGEMENT") {
          myGeofence = element.isVisible;
        }
        if (element.name == "TERRITORY_MANAGEMENT") {
          territoryManagementMenu = element.isVisible;
        }
        if (element?.name == "USER_MANAGEMENT") {
          userMenu = element.isVisible;
        }
        if (element?.name === "COMPANY_MANAGEMENT") {
          companyMenu = element.isVisible;
        }
        if (element.name == "TRANSPORTER_MANAGEMENT") {
          vendorMenu = element.isVisible;
        }
        if (element.name == "VEHICLE_MANAGEMENT") {
          vehicleMenu = element.isVisible;
        }
        if (element.name == "CUSTOMER_VEHICLE_MANAGEMENT") {
          customerVehicleMenu = element.isVisible;
        }
        if (element.name == "MAP_VIEW") {
          mapViewMenu = element.isVisible;
        }
        if (element.name == "SITE_MANAGEMENT") {
          siteMenu = element.isVisible;
        }
        if (element.name == "ROUTE_MANAGEMENT") {
          routeMenu = element.isVisible;
        }
        if (element.name == "TRACK_HISTORY") {
          trackMenu = element.isVisible;
        }
        if (element.name == "SUBSCRIPTION_MASTER") {
          SubscriptionMaster = element.isVisible;
        }
        if (element.name == "TRIP_MANAGEMENT") {
          tripMenu = element.isVisible;
        }
        if (element.name == "FUEL_MANAGEMENT") {
          fuelMenu = element.isVisible;
        }
        if (element.name == "FUEL_MANAGEMENT") {
          fuelReport = element.isVisible;
        }
        if (element.name == "REPORTS") {
          reportMenu = element.isVisible;
        }
        if (element.name == "NOTIFICATION CONFIGURATION") {
          notificationMenu = element.isVisible;
        }
        if (element.name == "MASTER_CONFIGURATION") {
          permissionControl = element.isVisible;
        }
        if (element.name == "MENU_MANAGEMENT") {
          sidemenu = element.isVisible;
        }
        if (element.name == "DEALER_LEDGER") {
          dealerLedger = element.isVisible;
        }
        if (element.name == "ACTIVATION_RENEWAL") {
          activationRenewal = element.isVisible;
        }
        if (element.name == "CUSTOMER_ACTIVATION_RENEWAL") {
          // customerActivationRenewal = element.isVisible;
        }
        // if (element.name == "UPDATE_ACTIVATION_RENEWAL") {
        //   UpdateActivationRenewal = element.isVisible;
        // }
        if (element.name == "PERMISSION_MANAGEMENT") {
          permissionMenu = element.isVisible;
        }
        if (element.name == "ROUTE_MANAGEMENT") {
          routeManagementMenu = element.isVisible;
        }
        if (element.name === "DRIVER_MANAGEMENT") {
          driverMenu = element.isVisible
        }
      });
  }

  // sub menu visibility Oct 13th 2022
  // for fuel management->fuelreports
  let fuelSummaryReport = true;
  let sensorCutVehicles = true;
  let fuelFillReport = true;
  let fuelDroppageReport = true;
  let gpsWirecutReport = true;
  let fuelGraphMisReport = true;
  let fuelEffiencyMisReport = true;
  let expectedVsActualReport = true;
  let fuelConsumptionReport = true;
  let fuelMisReport = true;
  let alertMisReport = true;
  let combineFuelReport = true;
  let dieselIssue = true;
  //for reports
  let summaryReport = true;
  let movementReport = true;
  let stoppageReport = true;
  let idleReport = true;
  let overSpeedReport = true;
  let geofenceReport = true;
  let routeDeviationReport = true;
  let tamperingReport = true;
  let auditLog = true;
  let Loginlogaudit = true;
  let activeRoutes = true;
  let gpsReport = false;
  let UpdateActivationRenewal = true;
  let SubMenuActivationRenewal = true;
  // for usermanagement-> dealer && customer submenu
  let dealerMenu = true;
  let customerMenu = true;
  // let driverMenu = true;
  let analyticsDashboardMenu = true;
  let trackingDashboardMenu = true;

  if (permissionAccess && permissionAccess.userTypeSubMenuVisiblity) {
    permissionAccess &&
      permissionAccess?.userTypeSubMenuVisiblity.forEach((element) => {
        if (element.name === "FUEL_SUMMARY_REPORT") {
          fuelSummaryReport = element.isVisible;
        } else if (element.name === "SENSOR_CUT_VEHICLES") {
          sensorCutVehicles = element.isVisible;
        } else if (element.name === "FUEL_FILL_REPORT") {
          fuelFillReport = element.isVisible;
        } else if (element.name === "FUEL_DROPPAGE_REPORT") {
          fuelDroppageReport = element.isVisible;
        } else if (element.name === "FUEL_WIRECUT_REPORT") {
          gpsWirecutReport = element.isVisible;
        } else if (element.name === "FUEL_GRAPH_MIS_REPORT") {
          fuelGraphMisReport = element.isVisible;
        } else if (element.name === "FUEL_EFFICIENCY_MIS_REPORT") {
          // fuel spelling mistake in api
          fuelEffiencyMisReport = element.isVisible;
        } else if (element.name === "EXPECTED_VS_ACTUAL_REPORT") {
          expectedVsActualReport = element.isVisible;
        } else if (element.name === "FUEL_CONSUMPTION_REPORT") {
          fuelConsumptionReport = element.isVisible;
        } else if (element.name === "FUEL_MIS_REPORT") {
          fuelMisReport = element.isVisible;
        } else if (element.name === "ALERT_MIS_REPORT") {
          // - instead of _ in api
          alertMisReport = element.isVisible;
        } else if (element.name === "COMBINE_FUEL_REPORT") {
          combineFuelReport = element.isVisible;
        } else if (element.name === "DIESEL_ISSUE") {
          dieselIssue = element.isVisible;
        }
        // for reports
        else if (element.name === "SUMMARY_REPORT") {
          summaryReport = element.isVisible;
        } else if (element.name === "MOVEMENT_REPORT") {
          movementReport = element.isVisible;
        } else if (element.name === "STOPPAGE_REPORT") {
          stoppageReport = element.isVisible;
        } else if (element.name === "IDLE_REPORT") {
          idleReport = element.isVisible;
          // idleReport = true;
        } else if (element.name === "OVER_SPEED_REPORT") {
          overSpeedReport = element.isVisible;
        } else if (element.name === "GEOFENCE_REPORT") {
          geofenceReport = element.isVisible;
        } else if (element.name === "ROUTE_DEVIATION_REPORT") {
          routeDeviationReport = element.isVisible;
        } else if (element.name === "TAMPERING_REPORT") {
          tamperingReport = element.isVisible;
        } else if (element.name === "AUDIT_LOG") {
          auditLog = element.isVisible;
        } else if (element.name === "LOGIN_LOG") {
          Loginlogaudit = element.isVisible;
        } else if (element.name === "ACTIVE_ROUTES") {
          activeRoutes = element.isVisible;
        } else if (element.name === "GPS_REPORT") {
          gpsReport = element.isVisible;
        } else if (element.name === "DEALER_MANAGEMENT") {
          dealerMenu = element.isVisible;
        } else if (element.name === "CUSTOMER_MANAGEMENT") {
          customerMenu = element.isVisible;
        } else if (element.name == "ACTIVATION_RENEWAL") {
          SubMenuActivationRenewal = element.isVisible;
        } else if (element.name == "UPDATE_ACTIVATION_RENEWAL") {
          UpdateActivationRenewal = element.isVisible;
        }
        // else if (element.name == "DRIVER_MANAGEMENT") {
        //   driverMenu = true;
        // }
        else if (element.name === "ANALYTICS_DASHBOARD") {
          analyticsDashboardMenu = element.isVisible;
        } else if (element.name === "TRACKING_DASHBOARD") {
          trackingDashboardMenu = element.isVisible;
        }
      });
  }

  // Add these permission variables
  let lockUnlockReport = canAccessLock; // Show if ONLY_DIGITAL_LOCK or BOTH
  let manualTripReport = canAccessLock; // Show if ONLY_DIGITAL_LOCK or BOTH
  let systemGeneratedTripReport = canAccessLock; // Show if ONLY_DIGITAL_LOCK or BOTH

  const handleLogout = async () => {
    window.open(`/`, "_self");
    window.localStorage.clear();
  };

  const handleClick = (value) => {
    localStorage.removeItem("payloadForDroppage");
    localStorage.setItem("fuelDetailsState", JSON.stringify(false));
    history.push(`/${value}`);
  };

  const mouseOutHandler = () => {
    let id1 = document.getElementsByClassName("dropdownFuel")[0]; //Fuel management
    let id2 = document.getElementsByClassName("dropdownFuel")[1]; // fuel management > Fuel report
    let id3 = document.getElementsByClassName("fuelMenuDashBoard")[0]; // fuel management > Dashboard
    id1.classList.remove("my-class");
    id2.classList.remove("my-class");
    id3.classList.remove("my-class");
  };

  const mouseOverHandler = () => {
    let id1 = document.getElementsByClassName("dropdownFuel")[0];
    let id2 = document.getElementsByClassName("dropdownFuel")[1];
    let id3 = document.getElementsByClassName("fuelMenuDashBoard")[0];

    id1.classList.add("my-class");
    id2.classList.add("my-class");
    id3.classList.add("my-class");
    setParentMenuColor(true);

    id2.addEventListener("mouseover", () => {
      id1.classList.add("my-class");
      const fuelReportSubmenusArray =
        document.getElementsByClassName("fuelReportSubmenu");
      console.log(fuelReportSubmenusArray);
      for (const subMenuUnit of fuelReportSubmenusArray) {
        subMenuUnit.addEventListener("mouseover", () => {
          subMenuUnit.classList.add("my-class_with-border");
          id1.classList.add("my-class");
          id2.classList.add("my-class");
          id3.classList.add("my-class");
        });
        subMenuUnit.addEventListener("mouseout", () => {
          subMenuUnit.classList.remove("my-class_with-border");
          id1.classList.remove("my-class");
          id2.classList.remove("my-class");
          id3.classList.remove("my-class");
        });
        subMenuUnit.classList.add("my-class", "shift_right");
      }

      const fuellevel1 = document.getElementsByClassName("fuelMenuDashBoard");
      for (const fuelinit1 of fuellevel1) {
        fuelinit1.addEventListener("mouseover", () => {
          fuelinit1.classList.add("my-class_with-border");
        });
        fuelinit1.addEventListener("mouseout", () => {
          fuelinit1.classList.remove("my-class_with-border");
        });
        fuelinit1.classList.add("my-class", "shift_right");
      }
    });
  };

  // const reportDropDown = document.getElementById("reportMenuBar");
  // console.log(reportDropDown)

  // reportDropDown.addEventListener("mouseover",()=>{
  //     let reportSubMenus=document.getElementsByClassName("reportSubMenu")

  //     for (const subMenuElement of reportSubMenus) {
  //         subMenuElement.classList.add("my-class_with-border")
  //     }
  // })

  const mouseOutHandlerForReports = () => {
    // let reportmainMenu=document.getElementsByClassName("dropdown")[0]
    // reportmainMenu.classList.remove("my-class")
  };

  const mouseOverForReportHandler = () => {
    let reportmainMenu = document.getElementsByClassName("dropdown")[0];
    reportmainMenu.classList.add("my-class");

    let reportSubMenuContainer =
      document.getElementsByClassName("showDivReport")[0];

    let reportSubMenus = document.getElementsByClassName("reportSubMenu");

    for (const subReportUnit of reportSubMenus) {
      subReportUnit.addEventListener("mouseover", () => {
        reportSubMenuContainer.classList.add("my-class");
        subReportUnit.classList.add("only-border");
      });
      subReportUnit.addEventListener("mouseout", () => {
        subReportUnit.classList.remove("only-border");
      });
    }

    // reportSubMenuContainer.addEventListener("mouseover",()=>{

    // })
    reportSubMenuContainer.addEventListener("mouseout", () => {
      reportmainMenu.classList.remove("my-class");
    });
  };

  // const handleMouseOverAddClass = () => {
  //     alert('Hey')
  // }

  // let navLinkHover = document.getElementsByClassName("navlink")
  // let dropdownNavLinkHover = document.getElementsByClassName("dropdownFuel")

  // for (const navLinkHoverItem of navLinkHover) {
  //     navLinkHoverItem.addEventListener("mouseover",()=>{
  //         navLinkHoverItem.classList.add("only-left-border")

  //     })
  //     navLinkHoverItem.addEventListener("mouseout",()=>{
  //         navLinkHoverItem.classList.remove("only-left-border")
  //     })
  // }

  return (
    <div className="sidebar">
      {localStorage.getItem("email") != "route@watsoo.com" && (
        <ul className="top-menu">
          {/* {dashboardMenu && (
            <li
              className={navClass("VehicleDashboard")}
              onClick={() => handleClick("VehicleDashboard")}
            >
              <div className="innerList">
                <DashboardIcon style={iconStyle} />
                <div className="sidebar-menu-text">Dashboard</div>
              </div>
            </li>
          )} */}
          {dashboardMenu && (
            <li
              className={`dashboard-parent ${isActive("stats-dashboard") || isActive("mapView")
                ? "active-nav-item"
                : ""
                }`}
            >
              {/* Parent row — icon + label */}
              <div className="innerList">
                <DashboardIcon
                  style={{
                    ...iconStyle,
                    color:
                      isActive("stats-dashboard") || isActive("mapView")
                        ? "#fff"
                        : iconStyle.color,
                  }}
                />
                <div className="sidebar-menu-text">Dashboard</div>
              </div>

              {/* Inline submenu */}
              <ul
                className="dashboard-submenu"
                onClick={(e) => e.stopPropagation()}
              >
                {analyticsDashboardMenu && (
                  <li
                    className={
                      isActive("stats-dashboard") ? "active-sub-item" : ""
                    }
                    onClick={() => handleClick("stats-dashboard")}
                  >
                    <div className="innerList">
                      <BarChartOutlinedIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">
                        Analytics Dashboard
                      </div>
                    </div>
                  </li>
                )}
                {trackingDashboardMenu && (
                  <li
                    className={
                      isActive("VehicleDashboard") ? "active-sub-item" : ""
                    }
                    onClick={() => handleClick("VehicleDashboard")}
                  >
                    <div className="innerList">
                      <MapOutlinedIcon style={{ ...iconStyle, fontSize: 18 }} />
                      <div className="sidebar-menu-text">
                        Tracking Dashboard
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </li>
          )}
          {/* {customerDashboardMenu && (
            // {JSON.parse(localStorage.getItem("data")).userType == "CUSTOMER" && (
            <li
              className={navClass("customer-dashboard")}
              onClick={() => handleClick("customer-dashboard")}
            >
              <div className="innerList">
                <DashboardIcon style={iconStyle} />
                <div className="sidebar-menu-text">Dashboard</div>
              </div>
            </li>
            // )}
          )} */}

          <li
            className={`dashboard-parent ${isActive("fmsDashboard") || isActive("fuelSummaryReport")
              ? "active-nav-item"
              : ""
              }`}
          >
            {/* Parent row — icon + label */}
            {/* <div className="innerList">
              <LocalGasStationOutlinedIcon
                style={{
                  ...iconStyle,
                  color:
                    isActive("fmsDashboard") || isActive("fuelSummaryReport")
                      ? "#fff"
                      : iconStyle.color,
                }}
              />
              <div className="sidebar-menu-text">FMS</div>
            </div> */}

            {/* Inline submenu */}
            <ul
              className="dashboard-submenu"
              onClick={(e) => e.stopPropagation()}
            >
              <li
                className={isActive("fmsDashboard") ? "active-sub-item" : ""}
                onClick={() => handleClick("fmsDashboard")}
              >
                <div className="innerList">
                  <DashboardIcon style={{ ...iconStyle, fontSize: 18 }} />
                  <div className="sidebar-menu-text">Dashboard</div>
                </div>
              </li>
              <li
                className={isActive("fuelSummaryReport") ? "active-sub-item" : ""}
                onClick={() => handleClick("fuelSummaryReport")}
              >
                <div className="innerList">
                  <SummarizeOutlinedIcon style={{ ...iconStyle, fontSize: 18 }} />
                  <div className="sidebar-menu-text">Fuel Summary Report</div>
                </div>
              </li>
              <li
                className={isActive("fuelFillReport") ? "active-sub-item" : ""}
                onClick={() => handleClick("fuelFillReport")}
              >
                <div className="innerList">
                  <LocalGasStationOutlinedIcon style={{ ...iconStyle, fontSize: 18 }} />
                  <div className="sidebar-menu-text">Fuel Fill Report</div>
                </div>
              </li>
              <li
                className={isActive("fuelDroppageReport") ? "active-sub-item" : ""}
                onClick={() => handleClick("fuelDroppageReport")}
              >
                <div className="innerList">
                  <TrendingDownOutlinedIcon style={{ ...iconStyle, fontSize: 18 }} />
                  <div className="sidebar-menu-text">Fuel Droppage Report</div>
                </div>
              </li>
            </ul>
          </li>

          {customerActivationRenewal ? (
            <li
              className={navClass("CustomerActivationRenewalList")}
              onClick={(e) => handleClick("CustomerActivationRenewalList")}
            >
              <div className="innerList">
                <AutorenewOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Activation/Renewal</div>
              </div>
            </li>
          ) : (
            ""
          )}
          {myGeofence ? (
            <li
              className={navClass("geofencelist")}
              onClick={() => handleClick("geofencelist")}
            >
              <div className="innerList">
                <MyLocationOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">My Geofence</div>
              </div>
            </li>
          ) : (
            ""
          )}

          {canAccessLock ? (
            <li
              className={navClass("LockConfigurations")}
              onClick={() => handleClick("LockConfigurations")}
            >
              <div className="innerList">
                <LockIcon style={iconStyle} />
                <div className="sidebar-menu-text">Lock Inventory</div>
              </div>
            </li>
          ) : (
            ""
          )}
          {routeManagementMenu ? (
            <li
              className={navClass("routeList")}
              onClick={() => handleClick("routeList")}
            >
              <div className="innerList">
                <RouteIcon style={iconStyle} />
                <div className="sidebar-menu-text">Route Management</div>
              </div>
            </li>
          ) : (
            ""
          )}
          {canAccessLock ? (
            <li
              className={navClass("DigitalLockTrips")}
              onClick={() => handleClick("DigitalLockTrips")}
            >
              <div className="innerList">
                <AirlineStopsOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Digital Lock Trips</div>
              </div>
            </li>
          ) : (
            ""
          )}
          {userMenu ? (
            <li
              className={`${navClass("subuserlist")} dropdownUser`}
            //onClick={() => handleClick("userlist")}
            >
              <div className="innerList">
                <PersonOutlineIcon style={iconStyle} />
                <div className="sidebar-menu-text">User Management</div>
              </div>

              {/* USER SUB MENU START */}
              {/* Dealer and Customer Submenu Oct 31 condition to be set later*/}
              <ul className="showDivUser" onClick={(e) => e.stopPropagation()}>
                {/* for dealer */}
                {dealerMenu ? (
                  <li
                    className={navClass("subuserlist?userType=dealer")}
                    onClick={(e) => handleClick("subuserlist?userType=dealer")}
                  >
                    <div className="innerList">
                      <PersonOutlineIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">Dealer Management</div>
                    </div>
                  </li>
                ) : (
                  ""
                )}

                {/* for customer */}
                {customerMenu ? (
                  <li
                    className={navClass("subuserlist?userType=customer")}
                    onClick={(e) =>
                      handleClick("subuserlist?userType=customer")
                    }
                  >
                    <div className="innerList">
                      <PersonOutlineIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">
                        Customer Management
                      </div>
                    </div>
                  </li>
                ) : (
                  ""
                )}
              </ul>

              {/* USER SUB MENU END */}
            </li>
          ) : (
            ""
          )}
          {/* role management */}
          {dealerLedger ? (
            <li
              className={navClass("dealerLedger")}
              onClick={() => handleClick("dealerLedger")}
            >
              <div className="innerList">
                <AccountBalanceWalletOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Dealer Ledger</div>
              </div>
            </li>
          ) : (
            ""
          )}

          {/* role management */}
          {viewAllUserPermission &&
            viewAllUserPermission.length > 0 &&
            sidemenu ? (
            <li
              className={navClass("rolelist")}
              onClick={() => handleClick("rolelist")}
            >
              <div className="innerList">
                <MenuBookOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Menu Management</div>
              </div>
            </li>
          ) : (
            ""
          )}
          {/* end */}

          {/* company management sept 5 */}
          {companyMenu &&
            localStorage.getItem("data") &&
            JSON.parse(localStorage.getItem("data")).userType.toUpperCase() ===
            "SUPER_ADMIN" && (
              <li
                className={navClass("companylist")}
                onClick={() => handleClick("companylist")}
              >
                <div className="innerList">
                  <BusinessOutlinedIcon style={iconStyle} />
                  <div className="sidebar-menu-text">Company Management</div>
                </div>
              </li>
            )}
          {/* company management end */}

          {false && viewAllVendorPermission.length > 0 && vendorMenu ? (
            <li
              className={navClass("transporterlist")}
              onClick={() => handleClick("transporterlist")}
            >
              <div className="innerList">
                <LocalShippingOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Transporter Management</div>
              </div>
            </li>
          ) : (
            ""
          )}
          {vehicleMenu ? (
            <li
              className={navClass("vehiclelist")}
              onClick={() => handleClick("vehiclelist")}
            >
              <div className="innerList">
                <DirectionsCarOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Vehicle Management</div>
              </div>
            </li>
          ) : (
            ""
          )}
          {driverMenu ? (
            <li
              className={navClass("driverlist")}
              onClick={() => handleClick("driverlist")}
            >
              <div className="innerList">
                <AirlineSeatReclineNormalIcon style={iconStyle} />
                <div className="sidebar-menu-text">Driver Management</div>
              </div>
            </li>
          ) : (
            ""
          )}

          {customerVehicleMenu ? (
            <li
              className={navClass("customervehiclelist")}
              onClick={() => handleClick("customervehiclelist")}
            >
              <div className="innerList">
                <DirectionsCarOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Vehicle Management</div>
              </div>
            </li>
          ) : (
            ""
          )}

          {mapViewMenu ? (
            <li
              className={navClass("mapView")}
              onClick={() => handleClick("mapView")}
            >
              <div className="innerList">
                <MapOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Map View</div>
              </div>
            </li>
          ) : (
            ""
          )}
          {/* for customer */}
          {/* {kycMenu ? (
            <li className="navlink" onClick={(e) => handleClick("kycMaster")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      new URLSearchParams(
                        window.location.search.replace("?", "")
                      ).get("userType") == "customer"
                        ? 1
                       : 1,
                  }}
                  className="ml-1"
                  src={userIcon}
                  alt="User"
                />
                <div className="sidebar-menu-text ml-2">
                  KYC Master{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )} */}
          {/* {userType !== "CUSTOMER" && activationRenewal ? (
            <li
              className="navlink"
              onClick={(e) => handleClick("activationRenewalList")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      new URLSearchParams(
                        window.location.search.replace("?", ""),
                      ).get("userType") == "customer"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={ActivationRenewal}
                  alt="activationRenewalList"
                />
                <div className="sidebar-menu-text ml-2">
                  Activation/Renewal{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )} */}
          {false && viewAllSitePermission.length > 0 && siteMenu ? (
            <li
              className={navClass("sitelist")}
              onClick={() => handleClick("sitelist")}
            >
              <div className="innerList">
                <LocationOnOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Site Management</div>
              </div>
            </li>
          ) : (
            ""
          )}
          {/* {viewAllRoutePermission &&
          viewAllRoutePermission.length > 0 &&
          routeMenu ? (
            <li
              className={navClass("routelist")}
              onClick={() => handleClick("routelist")}
            >
              <div className="innerList">
                <AltRouteOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Route Management</div>
              </div>
            </li>
          ) : (
            ""
          )} */}
          {SubscriptionMaster ? (
            <li
              className={navClass("SubscriptionMaster")}
              onClick={() => handleClick("SubscriptionMaster")}
            >
              <div className="innerList">
                <CardMembershipOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Subscription Master</div>
              </div>
            </li>
          ) : (
            ""
          )}

          {trackMenu && (
            <li
              className={navClass("history")}
              onClick={() => handleClick("history/0")}
            >
              <div className="innerList">
                <HistoryOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Track History</div>
              </div>
            </li>
          )}
          {/* {trackMenu && (
            <li
              className={navClass("travelJourney")}
              onClick={() => handleClick("travelJourney")}
            >
              <div className="innerList">
                <TimelineOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Travel Journey</div>
              </div>
            </li>
          )} */}
          {(notificationMenu && canAccessFixedGPS(accessType)) ? (
            <li
              className={navClass("NotificationConfigurations")}
              onClick={() => handleClick("NotificationConfigurations")}
            >
              <div className="innerList">
                <NotificationsOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">
                  Notification Configuration
                </div>
              </div>
            </li>
          ) : (
            ""
          )}
          {false && (
            <li
              className="navlink"
              onClick={() => handleClick("VehicleActivation")}
            >
              <div className="innerList">
                <HistoryOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Vehicle Activation</div>
              </div>
            </li>
          )}
          {viewAllTripPermission &&
            viewAllTripPermission.length > 0 &&
            tripMenu ? (
            <li
              className={navClass("triplist")}
              onClick={() => handleClick("triplist")}
            >
              <div className="innerList">
                <LocationOnOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Trip Management</div>
              </div>
            </li>
          ) : (
            ""
          )}

          {false ? (
            <li
              className="navlink"
              onClick={() => handleClick("subscriptionMasterList")}
            >
              <div className="innerList">
                <CardMembershipOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Subscription Management</div>
              </div>
            </li>
          ) : (
            ""
          )}

          {false && viewAllTripPermission.length > 0 && notificationMenu ? (
            <li
              className="navlink"
              onClick={() => handleClick("notificationConfigure")}
            >
              <div className="innerList">
                <NotificationsOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">
                  Notification Configuration
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {false && viewAllReportPermission.length > 0 && fuelMenu && (
            <li
              className="navlink dropdownFuel"
              onMouseOut={mouseOutHandler}
              style={parentMenuColor ? { color: "orange" } : { color: "white" }}
            >
              <div className="innerList">
                <LocalGasStationOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Fuel Management</div>
              </div>

              {/* DropDown */}

              <ul className="showDivFuel">
                <li
                  className="navlink fuelMenuDashBoard"
                  onClick={() => handleClick("fuelDashboard")}
                >
                  <div className="innerList">
                    {/* <img
                      style={{
                        opacity:
                          window.location.search.split("?")[1] ==
                          "type=fuelDashboard"
                            ? 1
                            : 1,
                      }}
                      src={dashboardIcon}
                      alt="route"
                    /> */}
                    <DashboardIcon
                      sx={{
                        fontSize: 22,
                        ml: 1,
                        color:
                          window.location.pathname.split("/")[1] ===
                            "type=fuelDashboard"
                            ? "#1976d2" // active color
                            : "#6c757d", // inactive color
                      }}
                    />
                    <div className="sidebar-menu-text ml-1 pl-3">
                      {" "}
                      Fuel Dashboard{" "}
                    </div>
                  </div>
                </li>
                {dieselIssue && (
                  <li
                    className="navlink fuelMenuDashBoard"
                    onClick={() => handleClick("Diesel_issue")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                              "type=Diesel_issue"
                              ? 1
                              : 1,
                        }}
                        src={fuelmanagementIcon}
                        alt="route"
                      />
                      <div className="sidebar-menu-text ml-1 pl-3">
                        {" "}
                        Diesel Issue
                      </div>
                    </div>
                  </li>
                )}

                {viewAllReportPermission.length > 0 && fuelReport && (
                  <li className="navlink dropdownFuel fuelMenuDashBoard">
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.pathname.split("/")[1] ==
                              "fuelreport" ||
                              window.location.pathname.split("/")[1] ==
                              "fuelreport"
                              ? 1
                              : 1,
                        }}
                        className="ml-1"
                        src={fuelmanagementIcon}
                        alt="route"
                      />
                      <div className="sidebar-menu-text ml-1 pl-3">
                        Fuel Reports{" "}
                      </div>
                    </div>
                    <ul className="innerShowDivFuel">
                      {fuelFillReport && (
                        <li
                          className="navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=FUELFILL")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                    "type=FUELFILL"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="sidebar-menu-text pl-4">
                              {" "}
                              Fuel Fill Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {fuelDroppageReport && (
                        <li
                          className="navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=FUELDROP")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                    "type=FUELDROP"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="sidebar-menu-text pl-4">
                              {" "}
                              Fuel Droppage Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {gpsWirecutReport && (
                        <li
                          className="navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=FUELWIRECUT")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                    "type=FUELWIRECUT"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="sidebar-menu-text pl-4">
                              {" "}
                              Gps Wirecut Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {sensorCutVehicles &&
                        localStorage.getItem("getsensordata") && (
                          <li
                            className="navlink fuelReportSubmenu"
                            onClick={() =>
                              handleClick("fuelreport?type=SENSORWIRECUT")
                            }
                          >
                            <div className="innerList">
                              <img
                                style={{
                                  opacity:
                                    window.location.search.split("?")[1] ==
                                      "fuelreport?type=SENSORWIRECUT"
                                      ? 1
                                      : 1,
                                }}
                                src={reportIcon}
                                alt="route"
                              />
                              <div className="sidebar-menu-text pl-4">
                                Sensor Wirecut Report
                              </div>
                            </div>
                          </li>
                        )}
                      {fuelSummaryReport && (
                        <li
                          className="navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=FUELSUMMARY")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                    "type=FUELSUMMARY"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="sidebar-menu-text pl-4">
                              Fuel Summary Report{" "}
                            </div>
                          </div>
                        </li>
                      )}

                      {/* {localStorage.getItem("getsensordata") && (
                        <li
                          className="navlink fuelReportSubmenu"
                          onClick={() => handleClick("SensorWirecut")}
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=SensorWirecut"
                                    ? 1
                                   : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="sidebar-menu-text pl-4">
                              {" "}
                              Sensor Cut Vehicles
                            </div>
                          </div>
                        </li>
                      )} */}

                      {fuelGraphMisReport && (
                        <li
                          className="navlink fuelReportSubmenu"
                          onClick={() => handleClick("fuelDetails/0")}
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                    "type=FUELGRAPH"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="sidebar-menu-text pl-4">
                              {" "}
                              Fuel Graph MIS Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {fuelEffiencyMisReport && (
                        <li
                          className="navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELEFFICIENCY&subType=FEMISREPORT",
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                    "type=FUELEFFICIENCY&subType=FEMISREPORT"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="sidebar-menu-text pl-4">
                              {" "}
                              Fuel Efficiency MIS Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {expectedVsActualReport && (
                        <li
                          className="navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELALERT&subType=EVAFMISREPORT",
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                    "type=FUELALERT&EVAFMISREPORT"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="sidebar-menu-text pl-4">
                              {" "}
                              Expected Vs Actual Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {fuelConsumptionReport && (
                        <li
                          className="navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELSUMMARY&subType=KMDMISREPORT",
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                    "type=FUELSUMMARY&subType=KMDMISREPORT"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="sidebar-menu-text pl-4">
                              {" "}
                              Fuel Consumption Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {fuelMisReport && (
                        <li
                          className="navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELSUMMARY&subType=FUELMISREPORT",
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                    "type=FUELSUMMARY&subType=FUELMISREPORT"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="sidebar-menu-text pl-4">
                              {" "}
                              Fuel MIS Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {alertMisReport && (
                        <li
                          className="navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=alertType")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                    "type=ODOMETER"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="sidebar-menu-text pl-4">
                              {" "}
                              Alert MIS Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {combineFuelReport && (
                        <li
                          className="navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELFILLDROPCOMBINEDREPORT",
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                    "type=FUELFILLDROPCOMBINEDREPORT"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="sidebar-menu-text pl-4">
                              {" "}
                              Combine Fuel Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
              </ul>
              {/* DropDownEnd */}
            </li>
          )}
          {/* {userType !== "CUSTOMER" &&
            // userType !== "DEALER" &&
            (UpdateActivationRenewal || SubMenuActivationRenewal) && (
              // ── CHANGED: was className="navlink dropdown dropdownFuel"
              // Now uses isAnyActive() so the parent gets active-nav-item
              // when any of its child routes is current, matching the
              // Dashboard parent pattern. Child <li>s are unchanged.
              <li
                className={`navlink dropdown dropdownFuel${isAnyActive("activationRenewalList", "updateDate") ? " active-nav-item" : ""}`}
                id="reportMenuBar"
                onMouseOut={mouseOutHandlerForReports}
              >
                <div className="innerList">
                  <AutorenewOutlinedIcon style={iconStyle} />
                  <div className="sidebar-menu-text">Activation/Renewal</div>
                </div>
                <ul className="showDivFuel">
                  {SubMenuActivationRenewal && (
                    <li
                      className={navClass("activationRenewalList")}
                      onClick={() => handleClick("activationRenewalList")}
                    >
                      <div className="innerList">
                        <SummarizeOutlinedIcon
                          style={{ ...iconStyle, fontSize: 18 }}
                        />
                        <div className="sidebar-menu-text">
                          Activation/Renewal Report
                        </div>
                      </div>
                    </li>
                  )}
                  {UpdateActivationRenewal && (
                    <li
                      className={navClass("updateDate")}
                      onClick={() => handleClick("updateDate")}
                    >
                      <div className="innerList">
                        <UpdateOutlinedIcon
                          style={{ ...iconStyle, fontSize: 18 }}
                        />
                        <div className="sidebar-menu-text">
                          Update Activation/Renewal
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </li>
            )} */}

          {/* territoryManagementMenu */}
          {territoryManagementMenu ? (
            <li
              className={navClass("TerritoryAndZoneManagement")}
              onClick={() => handleClick("TerritoryAndZoneManagement")}
            >
              <div className="innerList">
                <AltRouteOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Territory Management</div>
              </div>
            </li>
          ) : (
            ""
          )}

          {permissionMenu && (
            <li
              className={navClass("RoleManagement")}
              onClick={() => handleClick("RoleManagement")}
            >
              <div className="innerList">
                <AdminPanelSettingsOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Roles Management</div>
              </div>
            </li>
          )}
          {permissionControl ? (
            <li
              className={navClass("PermissionController")}
              onClick={() => handleClick("PermissionController")}
            >
              <div className="innerList">
                <TuneIcon style={iconStyle} />
                <div className="sidebar-menu-text">
                  Permissions Control
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {reportMenu && (
            <li
              className={`navlink dropdown dropdownFuel${isAnyActive(
                "Summary",
                "Movement",
                "reports?type=Stoppage",
                "reports?type=overspeed",
                "reports?type=GeoFenceDetail",
                "reports?type=routedeviation",
                "reports?type=Tampering",
                "audit",
                "Loginlogaudit",
                "activeRoutes",
                "upTime",
                "reportsgps",
                "Stoppage",
                "IdleReport",
                "DailyDistanceReport",
                "TripReport",
                "EventReport",
              )
                ? " active-nav-item"
                : ""
                }`}
              id="reportMenuBar"
              onMouseOut={mouseOutHandlerForReports}
            >
              <div className="innerList">
                <AssessmentOutlinedIcon style={iconStyle} />
                <div className="sidebar-menu-text">Reports</div>
              </div>
              <ul className="showDivFuel">
                {/* {summaryReport && (
                  <li
                    className={`${navClass("Summary")} reportSubMenu`}
                    onClick={() => handleClick("Summary")}
                  >
                    <div className="innerList">
                      <SummarizeOutlinedIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">Summary Report</div>
                    </div>
                  </li>
                )} */}
                {/* {movementReport && (
                  <li
                    className={`${navClass("Movement")} reportSubMenu`}
                    onClick={() => handleClick("Movement")}
                  >
                    <div className="innerList">
                      <DirectionsRunOutlinedIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">Movement Report</div>
                    </div>
                  </li>
                )}
                {stoppageReport && (
                  <li
                    className={`${navClass("reports?type=Stoppage")} reportSubMenu`}
                    onClick={() => handleClick("reports?type=Stoppage")}
                  >
                    <div className="innerList">
                      <PauseCircleOutlineOutlinedIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">Stoppage Report</div>
                    </div>
                  </li>
                )} */}
                {overSpeedReport && (
                  <li
                    className={`${navClass("reports?type=overspeed")} reportSubMenu`}
                    onClick={() => handleClick("reports?type=overspeed")}
                  >
                    <div className="innerList">
                      <SpeedOutlinedIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">Over Speed Report</div>
                    </div>
                  </li>
                )}
                {geofenceReport && (
                  <li
                    className={`${navClass("reports?type=GeoFenceDetail")} reportSubMenu`}
                    onClick={() => handleClick("reports?type=GeoFenceDetail")}
                  >
                    <div className="innerList">
                      <FenceOutlinedIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">Geofence Report</div>
                    </div>
                  </li>
                )}
                {routeDeviationReport && (
                  <li
                    className={`${navClass("reports?type=routedeviation")} reportSubMenu`}
                    onClick={() => handleClick("reports?type=routedeviation")}
                  >
                    <div className="innerList">
                      <AltRouteOutlinedIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">
                        Route Deviation Report
                      </div>
                    </div>
                  </li>
                )}
                {tamperingReport && (
                  <li
                    className={`${navClass("reports?type=Tampering")} reportSubMenu`}
                    onClick={() => handleClick("reports?type=Tampering")}
                  >
                    <div className="innerList">
                      <ReportProblemOutlinedIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">Tampering Report</div>
                    </div>
                  </li>
                )}
                {auditLog &&
                  viewAllReportAuditPermission &&
                  viewAllReportAuditPermission.length > 0 && (
                    <li
                      className={`${navClass("audit")} reportSubMenu`}
                      onClick={() => handleClick("audit")}
                    >
                      <div className="innerList">
                        <ReceiptLongOutlinedIcon
                          style={{ ...iconStyle, fontSize: 18 }}
                        />
                        <div className="sidebar-menu-text">Audit Log</div>
                      </div>
                    </li>
                  )}
                {auditLog &&
                  viewAllReportAuditPermission &&
                  viewAllReportAuditPermission.length > 0 && (
                    <li
                      className={`${navClass("Loginlogaudit")} reportSubMenu`}
                      onClick={() => handleClick("Loginlogaudit")}
                    >
                      <div className="innerList">
                        <LoginOutlinedIcon
                          style={{ ...iconStyle, fontSize: 18 }}
                        />
                        <div className="sidebar-menu-text">Login Log</div>
                      </div>
                    </li>
                  )}

                {activeRoutes &&
                  viewAllReportActiveRoutesPermission &&
                  viewAllReportActiveRoutesPermission.length > 0 && (
                    <li
                      className={`${navClass("activeRoutes")} reportSubMenu`}
                      onClick={() => handleClick("activeRoutes")}
                    >
                      <div className="innerList">
                        <TimelineOutlinedIcon
                          style={{ ...iconStyle, fontSize: 18 }}
                        />
                        <div className="sidebar-menu-text">Active Routes</div>
                      </div>
                    </li>
                  )}
                {localStorage.getItem("email") == "watsoo@watsoo.com" && (
                  <li
                    className={`${navClass("upTime")} reportSubMenu`}
                    onClick={() => handleClick("upTime")}
                  >
                    <div className="innerList">
                      <UpdateOutlinedIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">Up Time Report</div>
                    </div>
                  </li>
                )}
                {((gpsReport && canAccessGPS) || JSON.parse(localStorage.getItem("data"))?.hasFixedLockPermission) && (
                  <>
                    <li
                      className={`${navClass("Stoppage")} reportSubMenu`}
                      onClick={() => handleClick("Stoppage")}
                    >
                      <div className="innerList">
                        <PauseCircleOutlineOutlinedIcon
                          style={{ ...iconStyle, fontSize: 18 }}
                        />
                        <div className="sidebar-menu-text">Stop Report</div>
                      </div>
                    </li>
                    <li
                      className={`${navClass("IdleReport")} reportSubMenu`}
                      onClick={() => handleClick("IdleReport")}
                    >
                      <div className="innerList">
                        {/* <PauseCircleOutlineOutlinedIcon
                          style={{ ...iconStyle, fontSize: 18 }}
                        /> */}
                        <GiNightSleep
                          style={{ ...iconStyle, fontSize: 18 }}
                        />
                        {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={18}
                            height={18}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{ color: iconStyle.color, flexShrink: 0 }}
                            aria-hidden="true"
                          >
                            <path d="M20.5 13.5A8.5 8.5 0 1 0 13.5 20.5" />
                            <path d="M12 7v5l3 1.5" />
                            <path d="M17.5 15.5v5M21 15.5v5" />
                          </svg> */}
                        {/* <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={18}
                                height={18}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ color: iconStyle.color, flexShrink: 0 }}
                                aria-hidden="true"
                              >
                                <path d="M3.5 17a9 9 0 1 1 17 0" />
                                <path d="M12 17 8.5 12.5" />
                                <circle cx="12" cy="17" r="1" />
                              </svg> */}
                        <div className="sidebar-menu-text">Idle Report</div>
                      </div>
                    </li>
                    <li
                      className={`${navClass("DailyDistanceReport")} reportSubMenu`}
                      onClick={() => handleClick("DailyDistanceReport")}
                    >
                      <div className="innerList">
                        <TimelineOutlinedIcon
                          style={{ ...iconStyle, fontSize: 18 }}
                        />
                        <div className="sidebar-menu-text">
                          Daily Distance Report
                        </div>
                      </div>
                    </li>
                    <li
                      className={`${navClass("Summary")} reportSubMenu`}
                      onClick={() => handleClick("Summary")}
                    >
                      <div className="innerList">
                        <SummarizeOutlinedIcon
                          style={{ ...iconStyle, fontSize: 18 }}
                        />
                        <div className="sidebar-menu-text">Summary Report</div>
                      </div>
                    </li>
                    <li
                      className={`${navClass("TripReport")} reportSubMenu`}
                      onClick={() => handleClick("TripReport")}
                    >
                      <div className="innerList">
                        <AltRouteOutlinedIcon
                          style={{ ...iconStyle, fontSize: 18 }}
                        />
                        <div className="sidebar-menu-text">Trip Report</div>
                      </div>
                    </li>

                    {/* <li
                      className={`${navClass("EventReport")} reportSubMenu`}
                      onClick={() => handleClick("EventReport")}
                    >
                      <div className="innerList">
                        <NotificationsOutlinedIcon
                          style={{ ...iconStyle, fontSize: 18 }}
                        />
                        <div className="sidebar-menu-text">Event Report</div>
                      </div>
                    </li> */}
                  </>
                )}
                <li
                  className={`${navClass("HistoryReport")} reportSubMenu`}
                  onClick={() => handleClick("HistoryReport")}
                >
                  <div className="innerList">
                    <HistoryOutlinedIcon
                      style={{ ...iconStyle, fontSize: 18 }}
                    />
                    <div className="sidebar-menu-text">Raw History Report</div>
                  </div>
                </li>

                {/* Digital Lock Reports */}
                {lockUnlockReport && canAccessLock && (
                  <li
                    className={`${navClass("lockUnlockReport")} reportSubMenu`}
                    onClick={() => handleClick("lockUnlockReport")}
                  >
                    <div className="innerList">
                      <LockIcon style={{ ...iconStyle, fontSize: 18 }} />
                      <div className="sidebar-menu-text">
                        Lock/Unlock Report
                      </div>
                    </div>
                  </li>
                )}
                {manualTripReport && canAccessLock && (
                  <li
                    className={`${navClass("manualTripReport")} reportSubMenu`}
                    onClick={() => handleClick("manualTripReport")}
                  >
                    <div className="innerList">
                      <DirectionsRunOutlinedIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">
                        Manual Trip Report
                      </div>
                    </div>
                  </li>
                )}
                {systemGeneratedTripReport && canAccessLock && (
                  <li
                    className={`${navClass("systemGeneratedTripReport")} reportSubMenu`}
                    onClick={() => handleClick("systemGeneratedTripReport")}
                  >
                    <div className="innerList">
                      <AirlineStopsOutlinedIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">
                        System-Generated Trip Report
                      </div>
                    </div>
                  </li>
                )}
                {/* {gpsReport && (
                  <li
                    className={`navlink dropdown dropdownFuel reportSubMenu${
                      isAnyActive(
                        "reportsgps",
                        "Stoppage",
                        "DailyDistanceReport",
                        "Summary",
                        "TripReport",
                        "EventReport",
                      )
                        ? " active-nav-item"
                        : ""
                    }`}
                  >
                    <div className="innerList">
                      <GpsFixedOutlinedIcon
                        style={{ ...iconStyle, fontSize: 18 }}
                      />
                      <div className="sidebar-menu-text">GPS Report</div>
                    </div>
                    <ul className="innerShowDivFuel">
                      <li
                        className={navClass("Stoppage")}
                        onClick={() => handleClick("Stoppage")}
                      >
                        <div className="innerList">
                          <div className="sidebar-menu-text">Stop Report</div>
                        </div>
                      </li>
                      <li
                        className={navClass("IdleReport")}
                        onClick={() => handleClick("IdleReport")}
                      >
                        <div className="innerList">
                          <div className="sidebar-menu-text">Idle Report</div>
                        </div>
                      </li>
                      <li
                        className={navClass("DailyDistanceReport")}
                        onClick={() => handleClick("DailyDistanceReport")}
                      >
                        <div className="innerList">
                          <div className="sidebar-menu-text">
                            Daily Distance Report
                          </div>
                        </div>
                      </li>
                      <li
                        className={navClass("Summary")}
                        onClick={() => handleClick("Summary")}
                      >
                        <div className="innerList">
                          <div className="sidebar-menu-text">
                            Summary Report
                          </div>
                        </div>
                      </li>
                      <li
                        className={navClass("TripReport")}
                        onClick={() => handleClick("TripReport")}
                      >
                        <div className="innerList">
                          <div className="sidebar-menu-text">Trip Report</div>
                        </div>
                      </li>
                      <li
                        className={navClass("EventReport")}
                        onClick={() => handleClick("EventReport")}
                      >
                        <div className="innerList">
                          <div className="sidebar-menu-text">Event Report</div>
                        </div>
                      </li>
                    </ul>
                  </li>
                )} */}
              </ul>
            </li>
          )}
          {/* <li className='showDivReport' onMouseOver={mouseOverForReportHandler} onMouseOut={mouseOutHandlerForReports}>
                    
    </li> */}



          {/* <li
            className={navClass("dashcamVideo")}
            onClick={() => handleClick("dashcamVideo")}
          >
            <div className="innerList">
              <VideocamOutlinedIcon style={iconStyle} />
              <div className="sidebar-menu-text">
                Dashcam
              </div>
            </div>
          </li> */}
        </ul>
      )}

      {localStorage.getItem("email") == "route@watsoo.com" && (
        <div
          className={navClass("routelist")}
          onClick={() => handleClick("routelist")}
        >
          <div className="innerList">
            <AltRouteOutlinedIcon style={iconStyle} />
            <div className="sidebar-menu-text">Route Management</div>
          </div>
        </div>
      )}

      {/* <div className="sidebar-logout-section">
        <div className="sidebar-logout-btn" onClick={handleLogout}>
          <LogoutOutlinedIcon style={{ ...iconStyle, fontSize: 20 }} />
          <div className="sidebar-logout-text">Log Out</div>
        </div>
        <div className="sidebar-version-text">Version {version}</div>
      </div> */}
    </div>
  );
}

export default Sidebar;
